<template>
  <!-- TODO nuxt3 remove root div -->
  <div class="ProfessionPageHeading">
    <BlockHeading
      :title="
        $t('professionalsPage.title', {
          thePerson: profession.theperson,
        })
      "
      :subtitle="
        $t('professionalsPage.subtitle', {
          thePerson: profession.theperson.toLowerCase(),
        })
      "
      :paragraph="
        $t('professionalsPage.titleParagraph', {
          professionObjective: profession.objective,
        })
      "
    />
  </div>
</template>

<script>
import { inject } from "@nuxtjs/composition-api";

export default {
  setup() {
    return {
      profession: inject("profession"),
    };
  },
};
</script>
